import { Component } from '@angular/core';
import { APP_NAME } from '../../environment';
import { NavItemsUser } from './NavItemsLoggedIn';
import { GlobalService } from '../../core/services/global.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent {

    username;
    urlString: string;
    currentLanguage: "en" | "ar" = "en"; // Default language
    NavItemsUser = NavItemsUser
    APP_NAME = APP_NAME;

    constructor(public global: GlobalService) {

    }

  isScrolled = false;
  isMobileMenuOpen = false;
  activeSection = 'about'; // Default active section 
 

    navigateToSection(sectionId: string, navItemId: string): void {
        const element = document.getElementById(sectionId);
        if (!element) return;
        this.activeSection = navItemId; 
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }

    // Language switching - URL generation for language switching
    generateUrlWithQueryParams(): string { 
        let urlC = this?.global?.urlForTheHeader;
        if (!urlC) return urlC;
        if (urlC?.includes('/ar')) {
            return urlC?.replace('/ar', '/en');
        } else if (urlC?.includes('/en')) {
            return urlC?.replace('/en', '/ar');
        }
        return urlC;
    }


}
